export default __webpack_public_path__ + "static/media/sticker-7.9407807a.png";